var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-block text-nowrap btn-success",class:{'btn-warning': _vm.value},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggle()}}},[_vm._v(_vm._s(_vm.value ? _vm.textOn : _vm.textOff))])
}
var staticRenderFns = []

export { render, staticRenderFns }